import { schema } from 'normalizr';

const entitySchema = new schema.Entity('organization', undefined, { idAttribute: 'id' });

export default entitySchema;